import { handleResponseOld, makePost } from './helpers';

/**
 * @category Help Scout API
 * @see fetchHelpScoutToken
 */
type FetchHelpScoutTokenParams = {
    appId: any;
    secret: any;
};
/**
 * Fetches Help Scout token via Post request directly to Help Scout API
 * @function fetchHelpScoutToken
 * @category Help Scout API
 * @param {FetchHelpScoutTokenParams}
 * @see https://api.helpscout.net/v2/oauth2/token
 */
const fetchHelpScoutToken = ({ appId, secret }: FetchHelpScoutTokenParams) =>
    new Promise<any>((resolve, reject) => {
        const request = makePost({
            apiPath: 'oauth2/token',
            path: '<HELP-SCOUT>',
        });
        request.send({
            client_id: appId,
            client_secret: secret,
            grant_type: 'client_credentials',
        });
        request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
    });

/**
 * @category Help Scout API
 * @see submitFeedback
 */
type SubmitFeedbackParams = {
    authToken: string;
    feedbackObject: any;
};
/**
 * Submits given feedback directly to Help Scout API
 * @function submitFeedback
 * @category Help Scout API
 * @param {SubmitFeedbackParams}
 * @see https://api.helpscout.net/v2/conversations
 */
const submitFeedback = ({ authToken, feedbackObject }: SubmitFeedbackParams) =>
    new Promise<any>((resolve, reject) => {
        const request = makePost({
            apiPath: 'conversations',
            authToken,
            path: '<HELP-SCOUT>',
        });
        request.send(feedbackObject);
        request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
    });

export default {
    fetchHelpScoutToken,
    submitFeedback,
};
